module.exports = require('./PageIcon');


/** WEBPACK FOOTER **
 ** ./demo/src/pages/icon/index.js
 **/